// src/pages/Pos.tsx
/*import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../services/api";
import BarcodeScanner from "../components/BarcodeScanner";
import { useKeyboardBarcode } from "../hooks/useKeyboardBarcode";

interface CartItem {
  product_id: number;
  name: string;
  price: number;
  quantity: number;
}

export default function Pos() {
  const location = useLocation();
  const scanMode = new URLSearchParams(location.search).get("scan");

  const [cart, setCart] = useState<CartItem[]>([]);
  const [showScanner, setShowScanner] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // ---------------- AUTO CAMERA TRIGGER ---------------- 
  useEffect(() => {
    if (scanMode === "camera") {
      setShowScanner(true);
    }
  }, [scanMode]);

  // ---------------- ADD TO CART ---------------- 
  const addToCart = (product: any, qty = 1) => {
    setCart((prev) => {
      const existing = prev.find(p => p.product_id === product.id);
      if (existing) {
        return prev.map(p =>
          p.product_id === product.id
            ? { ...p, quantity: p.quantity + qty }
            : p
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          quantity: qty
        }
      ];
    });
  };

  // ---------------- BARCODE HANDLER (API) ---------------- 
  const handleBarcode = async (code: string) => {
    try {
      const res = await api.get(`/products/barcode/${code}`);
      addToCart(res.data, 1);
      setShowScanner(false);
    } catch {
      setError("Product not found");
    }
  };

  // ---------------- USB / KEYBOARD SCANNER ---------------- 
  useKeyboardBarcode(handleBarcode);

  // ---------------- CHECKOUT ---------------- 
  const checkout = async () => {
    if (!cart.length) return;

    await api.post("/sales", { items: cart });
    setCart([]);
  };

  // ---------------- KEYBOARD SHORTCUTS ---------------- 
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "F2") checkout();
      if (e.key === "Escape") setCart([]);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [cart]);

  return (
    <div className="container-fluid p-4">
      <h3 className="mb-3">Point of Sale</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      {showScanner && (
        <div className="mb-3">
          <BarcodeScanner onDetected={handleBarcode} />
        </div>
      )}

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Product</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {cart.map(item => (
            <tr key={item.product_id}>
              <td>{item.name}</td>
              <td>{item.quantity}</td>
              <td>{item.price}</td>
              <td>{item.price * item.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="btn btn-success btn-lg" onClick={checkout}>
        Checkout (F2)
      </button>
    </div>
  );
}
*/



/*

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isMobileDevice } from "../utils/device";
import api from "../services/api";
import BarcodeScanner from "../components/BarcodeScanner";
import ProductSearch from "../components/ProductSearch";
import ProductInfo from "../components/ProductInfo";
import { notifyInfo } from "../services/toast";

export default function Pos() {
  const location = useLocation();
  const mode = new URLSearchParams(location.search).get("mode");

  const [product, setProduct] = useState<any>(null);
  const [useCamera, setUseCamera] = useState(false);

  useEffect(() => {
    if (mode === "lookup") {
      if (isMobileDevice()) {
        setUseCamera(true);
      } else {
        notifyInfo("Type product name to search");
      }
    }
  }, [mode]);

  const handleBarcode = async (code: string) => {
    const res = await api.get(`/products/barcode/${code}`);
    setProduct(res.data);
    setUseCamera(false);
  };

  return (
    <div className="container p-4">
      <h3>Product Lookup</h3>

      {!isMobileDevice() && <ProductSearch onSelect={setProduct} />}

      {useCamera && <BarcodeScanner onDetected={handleBarcode} />}

      <ProductInfo product={product} />
    </div>
  );
}
*/
/*
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import BarcodeScanner from "../components/BarcodeScanner";
import ProductSearch from "../components/ProductSearch";
import ProductInfo from "../components/ProductInfo";
import { getDeviceType } from "../utils/device";

export default function POS() {
  const [params] = useSearchParams();
  const [barcode, setBarcode] = useState<string | null>(null);
  const device = getDeviceType();

  const mode = params.get("scan") || params.get("mode");

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">
        POS Terminal ({device === "mobile" ? "📱 Mobile" : "🖥️ Desktop"})
      </h4>

      {// MOBILE CAMERA SCAN }
      {device === "mobile" && mode === "camera" && (
        <BarcodeScanner onDetected={setBarcode} />
      )}

      {// DESKTOP SEARCH }
      {device === "desktop" && (
        <ProductSearch onSelect={(code) => setBarcode(code)} />
      )}

      {// PRODUCT DETAILS }
      {barcode && <ProductInfo barcode={barcode} />}
    </div>
  );
}
*/

// src/pages/Pos.tsx
import { useLocation } from "react-router-dom";
import api from "../services/api";
import BarcodeScanner from "../components/BarcodeScanner";
import { useKeyboardBarcode } from "../hooks/useKeyboardBarcode";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

interface CartItem {
  product_id: number;
  name: string;
  price: number;
  quantity: number;
}

export default function Pos() {
  const location = useLocation();
  const scanMode = new URLSearchParams(location.search).get("scan");

  const [cart, setCart] = useState<CartItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  // ---------------- ADD TO CART ----------------
  const addToCart = (product: any, qty = 1) => {
    setCart((prev) => {
      const existing = prev.find((p) => p.product_id === product.id);
      if (existing) {
        return prev.map((p) =>
          p.product_id === product.id
            ? { ...p, quantity: p.quantity + qty }
            : p
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          quantity: qty,
        },
      ];
    });
  };

  // ---------------- BARCODE HANDLER ----------------
  const handleBarcode = async (code: string) => {
    try {
      const res = await api.get(`/products/barcode/${encodeURIComponent(code)}`);
      if (res.data) {
        addToCart(res.data, 1);
      } else {
        setError("Product not found");
      }
    } catch {
      setError("Product not found");
    }
  };

  // ---------------- USB / KEYBOARD SCANNER ----------------
  useKeyboardBarcode(handleBarcode);

  // ---------------- CHECKOUT ----------------
  const checkout = async () => {
    if (!cart.length) return;
    try {
      const res = await api.post("/sales", { items: cart, payment_method: "cash" });
      toast.success(`Sale completed. Status: ${res.data.status}`);
      setCart([]);
    } catch {
      toast.error("Checkout failed");
    }
  };

  // ---------------- KEYBOARD SHORTCUTS ----------------
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "F2") checkout();
      if (e.key === "Escape") setCart([]);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [cart]);

  return (
    <div className="container-fluid p-4">
      <h3 className="mb-3">Point of Sale</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      {scanMode === "camera" && (
        <div className="mb-3">
          <BarcodeScanner onDetected={handleBarcode} />
        </div>
      )}

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Product</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {cart.map((item) => (
            <tr key={item.product_id}>
              <td>{item.name}</td>
              <td>{item.quantity}</td>
              <td>{item.price}</td>
              <td>{item.price * item.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="btn btn-success btn-lg" onClick={checkout}>
        Checkout (F2)
      </button>
    </div>
  );
}


